import { defineAsyncComponent, ref, Ref } from 'vue'

let instance: any = null

const createInstance = () => {
    const component = ref()
    const visible: Ref<boolean> = ref(false)
    const width: Ref<string> = ref('60%')
    const props = ref<any>({})
    const title: Ref<string> = ref('')
    const subtitle: Ref<string> = ref('')
    const buttons: Ref<any[]> = ref([])
    const error: Ref<string> = ref('')
    const backgroundClose = ref(true)
    let onDismiss: any = null

    const show = async (params: any) => {
        component.value = defineAsyncComponent(params.component)
        visible.value = true
        width.value = params.width || '60%'
        props.value = params.props
        title.value = params.title
        subtitle.value = params.subtitle || ''
        buttons.value = params.buttons
        error.value = ''
        backgroundClose.value = params.backgroundClose === false ? false : true
        onDismiss = params.onDismiss
    }

    const dismiss = () => {
        component.value = null
        visible.value = false
        props.value = {}
        title.value = ''
        subtitle.value = ''
        error.value = ''
        buttons.value = []
        onDismiss = null
    }

    return {
        component,
        visible,
        width,
        props,
        title,
        subtitle,
        buttons,
        error,
        backgroundClose,
        onDismiss,
        show,
        dismiss
    }
}

export const useModalBox = () => {
    if (instance) {
        return {
            modalBox: instance
        }
    }
    instance = createInstance()
    return {
        modalBox: instance
    }
}
